/* Native documented Shopify Cart API for discounts. Shipping stays an explicit server-side estimate until checkout has an address. */
(function () {
  'use strict';
  if (window.ebromCartUI) return;
  window.ebromCartUI = true;
  var root = (window.Shopify && window.Shopify.routes.root) || '/';
  var english = /^en(?:-|$)/i.test(document.documentElement.lang || '');
  var state = { input: '', error: '', code: '', touched: false, busy: false };
  function paint() {
    document.querySelectorAll('[data-cart-coupon]').forEach(function (section) {
      var input = section.querySelector('[data-coupon-input]'), message = section.querySelector('[data-coupon-message]'), button = section.querySelector('[data-coupon-apply]'), clear = section.querySelector('[data-coupon-clear]');
      var server = section.querySelector('[data-coupon-server-code]');
      if (!state.touched && server) state.code = server.dataset.couponServerCode;
      if (input.value !== state.input) input.value = state.input;
      var text = state.error || (state.code ? (english ? 'Discount: ' : 'Gutschein: ') + state.code : '');
      if (message.textContent !== text) message.textContent = text;
      clear.hidden = !state.code;
      button.disabled = state.busy || !state.input.trim();
      if (button.textContent !== (state.busy ? '…' : 'OK')) button.textContent = state.busy ? '…' : 'OK';
    });
  }
  async function json(url, options) {
    var response = await fetch(root + url, Object.assign({ credentials: 'same-origin', cache: 'no-store' }, options));
    var data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'Shopify request failed');
    return data;
  }
  function refresh() {
    if (window.BoosterTheme && BoosterTheme.cart) return BoosterTheme.cart.dispatchListeners({ change: true });
    window.location.reload();
  }
  async function apply(section, clear) {
    var input = section.querySelector('[data-coupon-input]'), button = section.querySelector('[data-coupon-apply]'), message = section.querySelector('[data-coupon-message]');
    var code = clear ? '' : input.value.trim();
    if (!clear && !code) return;
    state.busy = true; state.error = ''; state.touched = true; paint();
    try {
      var data = await json('cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: code }) });
      var accepted = !code || (data.discount_codes || []).some(function (c) { return c.code.toLowerCase() === code.toLowerCase() && c.applicable; });
      if (!accepted) {
        state.error = english ? 'This discount code is not valid for your cart.' : 'Gutscheincode ist für diesen Warenkorb nicht gültig.';
        // An inapplicable code must not leave a warning staged in checkout or
        // replace a previously accepted code. Restore the prior single-code UI.
        await json('cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: state.code || '' }) });
        return;
      }
      state.code = code; state.input = '';
      localStorage.removeItem('discountCode');
      await refresh();
    } catch (e) { state.error = english ? 'The discount code could not be checked. Please try again.' : 'Gutschein konnte nicht geprüft werden. Bitte erneut versuchen.'; }
    finally { state.busy = false; paint(); }
  }
  document.addEventListener('input', function (e) {
    if (!e.target.matches('[data-coupon-input]')) return;
    state.input = e.target.value; state.error = ''; paint();
  });
  document.addEventListener('click', function (e) {
    var button = e.target.closest('[data-coupon-apply],[data-coupon-clear]');
    if (!button) return;
    e.preventDefault(); apply(button.closest('[data-cart-coupon]'), button.hasAttribute('data-coupon-clear'));
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches('[data-coupon-input]')) { e.preventDefault(); apply(e.target.closest('[data-cart-coupon]'), false); }
  });
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-recommendation-variant]')) return;
    var card = e.target.closest('[data-cart-recommendation]');
    card.querySelector('[data-recommendation-price]').textContent = e.target.selectedOptions[0].dataset.price;
  });
  document.addEventListener('click', async function (e) {
    var button = e.target.closest('[data-recommendation-add]');
    if (!button || button.disabled) return;
    e.preventDefault();
    var card = button.closest('[data-cart-recommendation]');
    var quantity = card.querySelector('[data-recommendation-quantity]');
    var amount = Number(quantity.value);
    var error = card.querySelector('[data-recommendation-error]');
    if (!Number.isInteger(amount) || amount < 1) { quantity.reportValidity(); return; }
    button.disabled = true; error.textContent = '';
    try {
      await json('cart/add.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:card.querySelector('[data-recommendation-variant]').value,quantity:amount}]})});
      await refresh();
    } catch (err) { error.textContent = 'Artikel konnte nicht hinzugefügt werden. Bitte erneut versuchen.'; }
    finally { button.disabled = false; }
  });

  function init() { new MutationObserver(paint).observe(document.body, { childList: true, subtree: true }); paint(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

})();
